module.exports = {"locales":["cs","sk","hu"],"defaultLocale":"cs","shallowLocale":"cs"}